const Facebook = () => (
    <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_460_190)">
            <path
                d="M15.8426 12.4345L16.4333 8.5865H12.7408V6.08941C12.7408 5.03689 13.2565 4.01027 14.9103 4.01027H16.5888V0.734419C16.5888 0.734419 15.0658 0.474609 13.6093 0.474609C10.5687 0.474609 8.58123 2.31786 8.58123 5.65418V8.58717H5.20105V12.4351H8.58123V21.7378H12.7408V12.4351L15.8426 12.4345Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_460_190">
                <rect
                    width="21.2632"
                    height="21.2632"
                    fill="white"
                    transform="translate(0.263306 0.473633)"
                />
            </clipPath>
        </defs>
    </svg>
);

export default Facebook;
